import { IFboBankAccount, IFboBankAccountsSummary } from '@common/interfaces/fboBankAccount'
import { combineReducers } from 'redux'
import { loadingArrayReducer } from '../../helpers/helpers'
import { createLoadingDataReducer } from '../../helpers/redux'
import {
  CREATE_FBO_BANK_ACCOUNT_REQUEST,
  GET_FBO_BANK_ACCOUNTS_SUMMARY_REQUEST,
  LIST_FBO_BANK_ACCOUNTS_REQUEST,
  prefix,
  UPDATE_FBO_BANK_ACCOUNT_REQUEST,
} from './actions'

export interface IFboBankAccountsData {
  data: IFboBankAccount[]
  totals: {
    totalItems: number
  }
}

export default combineReducers({
  loadingArray: loadingArrayReducer([prefix]),
  accounts: createLoadingDataReducer<IFboBankAccountsData>(
    [LIST_FBO_BANK_ACCOUNTS_REQUEST],
    [CREATE_FBO_BANK_ACCOUNT_REQUEST, UPDATE_FBO_BANK_ACCOUNT_REQUEST],
  ),
  summary: createLoadingDataReducer<IFboBankAccountsSummary>([
    GET_FBO_BANK_ACCOUNTS_SUMMARY_REQUEST,
  ]),
})
